exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-mobile-solution .mobile-solution[data-v-a98f69d6]{width:1024px;max-width:100%;margin-left:auto;margin-right:auto}", ""]);

// exports
